import React from "react";

function BenefitImage({ imageSrc, imageWidth, fade }) {

  const imageClass = `mx-auto pt-8 sm:pt-0 object-contain px-4 ${imageWidth}`
  const dataAOS = `fade-${fade}`

  return (
    <div className="w-full md:w-1/2" data-aos={dataAOS}>
      <img className={imageClass} src={imageSrc} alt="how-it-works" />
    </div>
  );
}

export default BenefitImage;